module.exports = __webpack_public_path__ + "static/wag-tags-5d6d47b78aa8d65d0ed64794f53eb87b.jpg";